
enum httpMethod {
    Get = 'GET',
    Post = 'POST',
    Delete = 'DELETE'
};

export async function GetMenuAsync() {
    return await RequestAsync(`${process.env.REACT_APP_MENU_BASE_URL}/menu.xls`, httpMethod.Get)
}

export async function RequestAsync(url: string, method: httpMethod, body?: any) {
    console.log(url);
    var requestOptions: RequestInit = {
        method: method,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            // 'time': moment().format()
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    };
    if (method == httpMethod.Post) {
        requestOptions.body = JSON.stringify(body);
    }

    return await fetch(url, requestOptions)
        .then(res => res.blob())
        .then((blob) => blob);
}